module.exports = __webpack_public_path__ + "img/Logout.07c6d493.svg";